/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AlarmActivationSummary = {
  /**
   * Number of cautionary alarms
   */
  caution: number;
  /**
   * Number of critical alarms
   */
  critical: number;
  /**
   * Number of warning alarms
   */
  warning: number;
};

/** @internal */
export const AlarmActivationSummary$inboundSchema: z.ZodType<
  AlarmActivationSummary,
  z.ZodTypeDef,
  unknown
> = z.object({
  caution: types.number(),
  critical: types.number(),
  warning: types.number(),
});

export function alarmActivationSummaryFromJSON(
  jsonString: string,
): SafeParseResult<AlarmActivationSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AlarmActivationSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AlarmActivationSummary' from JSON`,
  );
}
